module.exports = __webpack_public_path__ + "img/PH.e975e8e3.svg";